export default {
  tab: {
    index: 'Ngày',
    weekly: 'Tuần',
    monthly: 'Tháng',
    quarterly: 'Quý',
    yearly: 'Năm',
  },

  prospectItem: {
    usMarket: 'CHỨNG KHOÁN MỸ',
    euroMarket: 'CHỨNG KHOÁN CHÂU ÂU',
    asianMarket: 'CHỨNG KHOÁN CHÂU Á',
    oilWtiPrice: 'GÍA DẦU WTI',
    commodity: 'HÀNG HÓA',
    brentOilPrice: 'DẦU BRENT',
    centralBankRate: 'LÃI SUẤT LIÊN NH',
    worldGoldPrice: 'VÀNG THẾ GIỚI',
    vnIndex: 'VN-INDEX',
    vnMarket: 'Chứng khoán Việt Nam',
    hnxIndex: 'HNX-INDEX',
    vn30: 'VN-30',
    hnx30: 'HNX-30',
    foreignFlow: 'GIAO DỊCH NƯỚC NGOÀI',

    Up: 'TĂNG',
    Down: 'GIẢM',

    Price: 'Giá',
    PriceChange: 'Thay Đổi Giá',
    PercentPriceChange: '% Thay Đổi Giá',

    ExchangeRate: 'Tỷ Giá Hối Đoái',
    PreviousExchangeRate: 'Tỷ Giá Hối Đoái Trước Điều Chỉnh',

    IndexValue: 'Chỉ Số',
    IndexChange: 'Thay Đổi',
    PercentIndexChange: '% Thay Đổi',

    ForeignBuyValueMatched: 'GTNN Mua',
    ForeignSellValueMatched: 'GTNN Bán',
    NetForeign: 'GTNN Ròng',
  },
};
